import { render, staticRenderFns } from "./noRight.vue?vue&type=template&id=40e38498&scoped=true"
import script from "./noRight.vue?vue&type=script&lang=js"
export * from "./noRight.vue?vue&type=script&lang=js"
import style0 from "./noRight.vue?vue&type=style&index=0&id=40e38498&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e38498",
  null
  
)

export default component.exports